// extracted by mini-css-extract-plugin
export var searchPanelFilters = "search-filters-module--search-panel-filters--Ry9lR";